import React from 'react'
import { BrowserRouter as Router, Route } from 'react-router-dom'
import { Grommet } from 'grommet'

import { AuthProvider } from '../Firebase/Auth'
import AddProperty from '../AddProperty/AddProperty'
import Home from '../Home/Home'
import Login from '../Login/Login'
import Onboarding from '../Onboarding/Onboarding'
import PrivateRoute from '../PrivateRoute/PrivateRoute'
import SignUp from '../Signup/Signup'
import LoadUserID from '../Loading/LoadUserID'
import SingleProperty from '../Property/SingleProperty'
import BottomBar from '../Menu/BottomBar'
import GlobalStyle from './GlobalStyles'
import CompareProperty from '../Compare/CompareProperty'

const theme = {
  global: {
    colors: {
      control: {
        dark: '#ff8f00',
        light: '#333'
      },
      active: {
        dark: 'orange',
        light: '#337'
      }
    }
  }
}

const App = () => {
  return (
    <AuthProvider>
      <Grommet theme={theme}>
        <GlobalStyle />
        <Router>
          <>
            <PrivateRoute exact path="/" component={Home} />
            <Route
              exact
              path="/add"
              render={() => (
                <LoadUserID>
                  <AddProperty />
                </LoadUserID>
              )}
            />
            <Route
              exact
              path="/compare"
              render={() => (
                <LoadUserID>
                  <CompareProperty />
                </LoadUserID>
              )}
            />
            <Route exact path="/login" component={Login} />
            <Route exact path="/signup" component={SignUp} />
            <Route
              exact
              path="/setup"
              render={() => (
                <LoadUserID>
                  <Onboarding />
                </LoadUserID>
              )}
            />
          </>
          <Route
            exact
            path="/property/:id/"
            render={(props) => (
              <LoadUserID {...props}>
                <SingleProperty />
              </LoadUserID>
            )}
          />
          <BottomBar />
        </Router>
      </Grommet>
    </AuthProvider>
  )
}

export default App
